import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Icon, Image, Popup, Table } from 'semantic-ui-react';

import { InstagramIcon, TiktokIcon } from '../../components/dyzio-icons';
import PlatformLink from './platform-link';
import { ROW_HEIGHT } from './constants';

const notPostedStyle = { color: '#d4d4d8' };
const mutedStyle = { color: '#c8c8d0' };
const subtitleStyle = {
  fontSize: '85%', color: '#9090a0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
};

const DEFAULT_IMAGE = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/no_image_available.png';

const rowStyle = { height: ROW_HEIGHT, cursor: 'pointer' };

const InfluencerRow = ({ creator, onSelect }) => {
  const influencer = creator.influencer || {};
  const handle = influencer.primarySocialHandle || influencer.name || creator.name;
  const subtitle = influencer.name && handle !== influencer.name ? influencer.name : null;

  return (
    <Table.Row style={rowStyle} onClick={() => onSelect(creator.id)}>
      <Table.Cell>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Image
            avatar
            size="mini"
            src={influencer.thumbnail || DEFAULT_IMAGE}
            onError={i => { i.target.src = DEFAULT_IMAGE; }}
            style={{ marginRight: 12, flexShrink: 0 }}
          />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {handle}
            </div>
            {subtitle &&
              <div className="light" style={subtitleStyle}>
                {subtitle}
              </div>}
          </div>
        </div>
      </Table.Cell>
      <Table.Cell style={{ whiteSpace: 'nowrap' }}>
        {influencer.instagram &&
          <PlatformLink
            href={`https://www.instagram.com/${influencer.instagram}`}
            icon={<InstagramIcon />}
            handle={influencer.instagram}
            count={influencer.instagramCount}
          />}
        {influencer.tiktok &&
          <PlatformLink
            href={`https://www.tiktok.com/@${influencer.tiktok}`}
            icon={<TiktokIcon />}
            handle={influencer.tiktok}
            count={influencer.tiktokCount}
          />}
      </Table.Cell>
      <Table.Cell textAlign="center">
        <Popup
          inverted
          size="tiny"
          content={creator.hasPosted ? 'This creator has posted' : 'No post tracked yet'}
          trigger={creator.hasPosted
            ? <Icon name="check circle" color="green" />
            : <Icon name="circle outline" style={notPostedStyle} />}
        />
      </Table.Cell>
      <Table.Cell textAlign="center" style={creator.storiesCount ? undefined : mutedStyle}>
        {creator.storiesCount || 0}
      </Table.Cell>
      <Table.Cell textAlign="center" style={creator.trackedAssetsCount ? undefined : mutedStyle}>
        {creator.trackedAssetsCount || 0}
      </Table.Cell>
      <Table.Cell
        style={{ color: '#9090a0', whiteSpace: 'nowrap' }}
        title={creator.lastScannedDate ? moment(creator.lastScannedDate).format('lll') : ''}
      >
        {creator.lastScannedDate ? moment(creator.lastScannedDate).fromNow() : 'Not scanned'}
      </Table.Cell>
    </Table.Row>
  );
};

InfluencerRow.propTypes = {
  creator: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    lastScannedDate: PropTypes.string,
    hasPosted: PropTypes.bool,
    storiesCount: PropTypes.number,
    trackedAssetsCount: PropTypes.number,
    influencer: PropTypes.object,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default InfluencerRow;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/influencer-row.js
 **/